import { TRACKING_STOP } from './TrackingStopActionType';
import { setTrackingInStore } from '../TrackingStore';

const trackingStopAction = () => () => {
    setTrackingInStore(false);
    return { type: TRACKING_STOP };
};

export { trackingStopAction };
